import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const GET_BENUTZER_EIGENSCHAFTEN_ADMIN = '[BenutzerverwaltungModul] GetBenutzerEigenschaftenAdmin laden';
export const GET_BENUTZER_EIGENSCHAFTEN_ADMIN_AUSFUEHREN = '[BenutzerverwaltungModul] GetBenutzerEigenschaftenAdmin ausführen';
export const GET_BENUTZER_EIGENSCHAFTEN_ADMIN_ERFOLGREICH = '[BenutzerverwaltungModul] GetBenutzerEigenschaftenAdmin laden erfolgreich';
export const GET_BENUTZER_EIGENSCHAFTEN_ADMIN_FEHLER = '[BenutzerverwaltungModul] GetBenutzerEigenschaftenAdmin Ladefehler';
export const GET_BENUTZER_EIGENSCHAFTEN_ADMIN_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] GetBenutzerEigenschaftenAdmin nicht ausgeführt (evtl. Offline)';


export class GetBenutzerEigenschaftenAdminAction implements Action {
    readonly type = GET_BENUTZER_EIGENSCHAFTEN_ADMIN;
        constructor( public benutzerId:string , public optPayload: any = null) {}
    }
export class GetBenutzerEigenschaftenAdminAusfuehrenAction implements Action {
    readonly type = GET_BENUTZER_EIGENSCHAFTEN_ADMIN_AUSFUEHREN;
        constructor( public benutzerId:string , public optPayload: any = null) {}
    }
export class GetBenutzerEigenschaftenAdminErfolgreichAction implements Action {
    readonly type = GET_BENUTZER_EIGENSCHAFTEN_ADMIN_ERFOLGREICH;
        constructor(public payload: api.BenutzerEigenschaftenForAdmin,  public benutzerId:string , public optPayload: any = null) {}
    }
export class GetBenutzerEigenschaftenAdminFehlerAction implements Action {
    readonly type = GET_BENUTZER_EIGENSCHAFTEN_ADMIN_FEHLER;
        constructor(public payload: any,  public benutzerId:string , public optPayload: any = null) {}
    }
export class GetBenutzerEigenschaftenAdminNichtAusgefuehrtAction implements Action {
    readonly type = GET_BENUTZER_EIGENSCHAFTEN_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungQueryBenutzerEigenschaftenAdminActions =
    GetBenutzerEigenschaftenAdminAction
    | GetBenutzerEigenschaftenAdminAusfuehrenAction
    | GetBenutzerEigenschaftenAdminErfolgreichAction
    | GetBenutzerEigenschaftenAdminFehlerAction
    | GetBenutzerEigenschaftenAdminNichtAusgefuehrtAction
    ;
